export default __webpack_public_path__ + "static/media/CNo.86-7.8f7b644f.jpg";